
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import CourseCard from '../CourseCard/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    CourseCard,
    NewSwiper
  }
})
export default class ProgressCourse extends Vue {
  current: number = 0
  prevBtnHover: boolean = false
  nextBtnHover: boolean = false

  @Ref()
  swiper: {
    handlePrev: () => void
    handleNext: () => void
    dotScrollTo: (idx: number) => void
  }

  get PageStore() {
    return this.$store.$myV2.Center
  }

  onDotScroll(idx: number) {
    if (!this.swiper) return

    this.swiper.dotScrollTo(idx)
  }

  onSwiperChange(idx: number) {
    this.current = idx
  }

  onPrev() {
    if (!this.swiper) return

    this.swiper.handlePrev()
  }

  onNext() {
    if (!this.swiper) return

    this.swiper.handleNext()
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
